import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { PaginatedBuyerOrgUserList } from 'lib/api/generated';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';

interface UseOrgUsersProps {
  orgId?: string;
  status?: 'PENDING' | 'APPROVED' | 'REJECTED';
}

/** Get the Org Users List */
export const useOrgUsers = ({
  orgId: overrideOrgId,
  status = 'APPROVED',
}: UseOrgUsersProps) => {
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);
  const finalOrgId = overrideOrgId || activeBuyerOrgId;

  return useQuery<PaginatedBuyerOrgUserList>(
    [QUERY_KEYS.orgUsers, finalOrgId, status],
    async () => {
      const res = await new ApiClient().OrganisationUsersApi.orgUserList({
        buyerOrgId: finalOrgId as string,
        pageSize: 100,
        status,
      });

      return res.data;
    },
    {
      enabled: !!finalOrgId,
    }
  );
};
